import React, { Component } from 'react';
import { Layout } from 'antd';
import Sider from './sider';
import Header from './header';
import { Footer } from '../common/footer/footer';
import { NAVIGATION_CONTENT_KEY, MAIN_CONTENT_KEY, HEADER_CONTENT_KEY } from './constants';
import './dashboard.css';

class Dashboard extends Component {
  get headerContent() {
    return this.getComponent(HEADER_CONTENT_KEY)[0];
  }

  get navigation() {
    return this.getComponent(NAVIGATION_CONTENT_KEY)[0];
  }

  get mainContent() {
    return this.getComponent(MAIN_CONTENT_KEY);
  }

  getComponent(key) {
    return this.props.children.filter((component) => component.key === key);
  }

  render() {
    return (
      <Layout className="dashboard-layout">
        <Header>
          {this.headerContent}
          {this.navigation}
        </Header>
        <Layout className="dashboard-layout__main">
          <Sider location={this.props.location} >
            {this.navigation}
          </Sider>
          <Layout.Content className="dashboard-layout__content">
            {this.mainContent}
          </Layout.Content>
        </Layout>
        <Footer/>
      </Layout>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.js